<template>
    <div class="user-profile-component">
        <div>
            {{updateColor()}}
        </div>
        
        <!-- Profile Section -->
        <div class="section-header" :style="sectionHeaderStyle">Profile Information</div>
        <div class="profile-fields-grid">
            <div class="field-card" 
                 @mouseenter="showBorder" 
                 @mouseleave="hideBorder"
                 :class="{ 'editing': modify }">
                <div class="field-label">Name</div>
                <div v-if="!modify" class="field-value">{{ userProfile.userName }}</div>
                <input v-else 
                       v-model="editableFields.userName" 
                       class="field-input" 
                       :style="inputFocusStyle"
                       @input="handleFieldChange('Name', $event.target.value)" />
            </div>

            <div class="field-card" 
                 @mouseenter="showBorder" 
                 @mouseleave="hideBorder"
                 :class="{ 'editing': modify }">
                <div class="field-label">Nickname</div>
                <div v-if="!modify" class="field-value">{{ userProfile.nickName }}</div>
                <input v-else 
                       v-model="editableFields.nickName" 
                       class="field-input" 
                       :style="inputFocusStyle"
                       @input="handleFieldChange('Nick Name', $event.target.value)" />
            </div>

            <div class="field-card" 
                 @mouseenter="showBorder" 
                 @mouseleave="hideBorder"
                 :class="{ 'editing': modify }">
                <div class="field-label">Gender</div>
                <div v-if="!modify" class="field-value">
                    {{ Array.isArray(userProfile.gender) ? userProfile.gender.join(', ') : userProfile.gender }}
                </div>
                <select v-else 
                        v-model="editableFields.gender" 
                        class="field-input" 
                        :style="inputFocusStyle"
                        @change="handleFieldChange('Gender', $event.target.value)">
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                </select>
            </div>
        </div>

        <!-- Contact Section -->
        <div class="section-header" :style="sectionHeaderStyle">Contact Information</div>
        <div class="profile-fields-grid">
            <div class="field-card" 
                 @mouseenter="showBorder" 
                 @mouseleave="hideBorder"
                 :class="{ 'editing': modify }">
                <div class="field-label">Email</div>
                <div v-if="!modify" class="field-value">{{ userProfile.email }}</div>
                <input v-else 
                       v-model="editableFields.email" 
                       class="field-input" 
                       type="email"
                       :style="inputFocusStyle"
                       @input="handleFieldChange('Email', $event.target.value)" />
            </div>

            <div class="field-card" 
                 @mouseenter="showBorder" 
                 @mouseleave="hideBorder"
                 :class="{ 'editing': modify }">
                <div class="field-label">Work Phone</div>
                <div v-if="!modify" class="field-value">{{ userProfile.workPhone }}</div>
                <input v-else 
                       v-model="editableFields.workPhone" 
                       class="field-input" 
                       type="tel"
                       :style="inputFocusStyle"
                       @input="handleFieldChange('Work Phone', $event.target.value)" />
            </div>

            <div class="field-card" 
                 @mouseenter="showBorder" 
                 @mouseleave="hideBorder"
                 :class="{ 'editing': modify }">
                <div class="field-label">Mobile</div>
                <div v-if="!modify" class="field-value">{{ userProfile.mobile }}</div>
                <input v-else 
                       v-model="editableFields.mobile" 
                       class="field-input" 
                       type="tel"
                       :style="inputFocusStyle"
                       @input="handleFieldChange('Mobile', $event.target.value)" />
            </div>
        </div>

        <!-- Security Section -->
        <div class="section-header" :style="sectionHeaderStyle">Security</div>
        <div class="profile-fields-grid">
            <div class="field-card" 
                 @mouseenter="showBorder" 
                 @mouseleave="hideBorder"
                 :class="{ 'editing': modify }">
                <div class="field-label">Password</div>
                <div v-if="!modify" class="field-value">******</div>
                <input v-else 
                       v-model="editableFields.password" 
                       class="field-input" 
                       type="password"
                       :style="inputFocusStyle"
                       @input="handleFieldChange('Password', $event.target.value)" />
            </div>
        </div>

        <div class="action-buttons">
            <button v-if="!modify" 
                    class="action-btn modify-btn" 
                    :style="buttonStyle"
                    @click="handleModify">
                MODIFY
            </button>
            <button v-if="modify" 
                    class="action-btn confirm-btn" 
                    :style="buttonStyle"
                    @click="handleConfirm">
                CONFIRM
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "unifiedUserProfileComponent",
    props: {
        userProfile: {
            type: Object,
        },
        titleList: {
            type: Object,
        }
    },
    data() {
        return {
            userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,
            userAvator: require('../../assets/avator_example.jpg'),
            idx: 0,
            modify: false,
            editableFields: {
                userName: '',
                nickName: '',
                gender: '',
                email: '',
                workPhone: '',
                mobile: '',
                password: ''
            }
        }
    },
    computed: {
        themeColor() {
            return '#FC7727'; // main orange
        },
        themeColorLight() {
            return 'rgba(252, 119, 39, 0.3)'; // lighter orange for shadows
        },
        themeColorHover() {
            return 'rgba(255, 180, 134, 0.657)'; // hover state
        },
        themeColorDark() {
            return '#e8661f'; // darker shade for depth
        },
        sectionHeaderStyle() {
            return {
                color: this.themeColor,
                borderBottomColor: this.themeColor
            };
        },
        buttonStyle() {
            return {
                backgroundColor: this.themeColor
            };
        },
        inputFocusStyle() {
            return {
                '--focus-color': this.themeColor,
                '--focus-shadow': `rgba(${this.userType === 1 ? '82, 38, 223' : '252, 119, 39'}, 0.1)`
            };
        }
    },
    watch: {
        userProfile: {
            handler(newProfile) {
                this.editableFields = {
                    userName: newProfile.userName || '',
                    nickName: newProfile.nickName || '',
                    gender: newProfile.gender || '',
                    email: newProfile.email || '',
                    workPhone: newProfile.workPhone || '',
                    mobile: newProfile.mobile || '',
                    password: newProfile.password || ''
                };
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {  
        if (window.localStorage.getItem("userType")) {
            this.userType = parseInt(window.localStorage.getItem("userType"));
        } else {
            this.$router.push({
                name: 'login',
            })
        }
    },
    methods: {
        showBorder(event) {
            if (!this.modify) {
                event.currentTarget.style.border = `2px solid ${this.themeColor}`;
                event.currentTarget.style.boxShadow = `0 4px 12px ${this.themeColorHover}`;
                event.currentTarget.style.transform = 'translateY(-2px)';
            }
        },

        hideBorder(event) {
            if (!this.modify) {
                event.currentTarget.style.border = '2px solid transparent';
                event.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                event.currentTarget.style.transform = 'translateY(0)';
            }
        },

        handleFieldChange(title, newContent) {
            this.$emit('changed', title, newContent);
        },

        handleModify() {
            this.modify = true;
            this.editableFields = {
                userName: this.userProfile.userName || '',
                nickName: this.userProfile.nickName || '',
                gender: this.userProfile.gender || '',
                email: this.userProfile.email || '',
                workPhone: this.userProfile.workPhone || '',
                mobile: this.userProfile.mobile || '',
                password: this.userProfile.password || ''
            };
            this.$emit('modifying');
        },
        
        handleConfirm() {
            this.modify = false;
            this.$emit('confirmed');
        },

        updateColor() {
            var r = document.querySelector(':root');
            r.style.setProperty('--MODIFYBK', this.$store.state.modifybk);
            r.style.setProperty('--MODIFY', this.$store.state.modify);
            r.style.setProperty('--CONFIRM', this.$store.state.confirm);
            // Set theme colors as CSS variables
            r.style.setProperty('--THEME-COLOR', this.themeColor);
            r.style.setProperty('--THEME-COLOR-LIGHT', this.themeColorLight);
        },
    },
    beforeRouteLeave (to, from, next) {
        if (this.modify) {
            const answer = window.confirm('Do you really want to leave? All unsaved changes will be lost!')
            if (answer) {
                next()
            } else {
                next(false)
            }
        } else {
            next()
        }
    }
}
</script>

<style scoped>
.user-profile-component {
    padding: 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
}

.section-header {
    font-size: 24px;
    font-weight: 600;
    margin: 30px 0 20px 0;
    padding-bottom: 10px;
    border-bottom: 2px solid;
    transition: color 0.3s ease, border-bottom-color 0.3s ease;
}

.section-header:first-of-type {
    margin-top: 0;
}

.profile-fields-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.field-card {
    background: rgba(255, 255, 255, 0.9);
    border: 2px solid transparent;
    border-radius: 12px;
    padding: 20px;
    transition: all 0.3s ease;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.field-card.editing {
    border: 2px solid var(--THEME-COLOR, #FC7727);
    box-shadow: 0 4px 16px var(--THEME-COLOR-LIGHT, rgba(252, 119, 39, 0.3));
    cursor: default;
}

.field-label {
    font-size: 12px;
    color: #666;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
}

.field-value {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    line-height: 1.4;
}

.field-input {
    border: none;
    outline: none;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 16px;
    color: #333;
    border: 1px solid #ddd;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.field-input:focus {
    border-color: var(--focus-color, #FF7F00);
    box-shadow: 0 0 0 3px var(--focus-shadow, rgba(252, 119, 39, 0.1));
}

.action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    padding-top: 30px;
    border-top: 1px solid #eee;
    margin-top: auto;
}

.action-btn {
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: white;
}

.action-btn.modify-btn {
    background-color: var(--MODIFYBK, #FF7F00);
}

.modify-btn:hover,
.confirm-btn:hover {
    background: #FF8C00;
    transform: translateY(-1px);
    filter: brightness(0.9);
    box-shadow: 0 4px 12px var(--THEME-COLOR-LIGHT, rgba(255, 127, 0, 0.3));
}

@media (max-width: 768px) {
    .user-profile-component {
        padding: 20px;
    }
    
    .profile-fields-grid {
        grid-template-columns: 1fr;
    }
    
    .action-buttons {
        flex-direction: column;
    }
    
    .section-header {
        font-size: 20px;
    }
}

@media (max-width: 1024px) {
    .profile-fields-grid {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }
}
</style>


// WEBPACK FOOTER //
// src/components/user-profile/UserProfile-Profile.vue